import { setActiveGymId, ensureGymId, getCachedGymId } from './receptionist/gymContext';

let warmedForGym = '';
let warmedRole = '';
let ownerWarmed = false;

/**
 * Light panel warmup — never full-scan members/memberships/payments on refresh.
 * Those tables are huge and starved page queries (loader felt stuck).
 * Pages load their own paged data; dashboard loads what it needs when opened.
 */
export async function warmPanelData(explicitGymId, options = {}) {
  const role = options.role === 'receptionist' ? 'receptionist' : 'admin';
  const gid = explicitGymId || getCachedGymId();
  if (!options.force && gid && warmedForGym === gid && warmedRole === role) return;

  if (gid) {
    setActiveGymId(gid);
    warmedForGym = gid;
    warmedRole = role;
  }

  try {
    if (!getCachedGymId()) await ensureGymId();

    // Ensure permanent walk-in member exists for this gym (admin + receptionist)
    try {
      const { ensureWalkInMember } = await import('./receptionist/walkInMember');
      await ensureWalkInMember();
    } catch {
      /* non-blocking */
    }

    // Only light lookups — branch names for selects. No full table downloads.
    try {
      const { fetchBranchNamesLite } = await import('./gym/catalogApi');
      await fetchBranchNamesLite().catch(() => []);
    } catch {
      /* non-blocking */
    }
  } catch {
    warmedForGym = '';
    warmedRole = '';
  }
}

/** Prefetch owner (platform) panel data. */
export async function warmOwnerPanelData() {
  if (ownerWarmed) return;
  ownerWarmed = true;

  try {
    const [
      { fetchDashboardData },
      { fetchGymAdminList, fetchGymFilterOptions },
      { fetchSaasPlans },
    ] = await Promise.all([
      import('./owner/financeApi'),
      import('./owner/gymAdminsApi'),
      import('./owner/subscriptionsApi'),
    ]);

    await Promise.all([
      fetchDashboardData().catch(() => null),
      fetchGymAdminList().catch(() => []),
      fetchGymFilterOptions().catch(() => ['All Gyms']),
      fetchSaasPlans().catch(() => []),
    ]);
  } catch {
    ownerWarmed = false;
  }
}

export function resetPanelWarmCache() {
  warmedForGym = '';
  warmedRole = '';
  ownerWarmed = false;
}
